module.exports = __webpack_public_path__ + "img/lbil_logo.c37b5950.png";